module.exports = __webpack_public_path__ + "static/media/tic-tac-toe.b4164c6a.gif";